








import Vue from "vue";

export default Vue.extend({
    name: "RecommendBanner",
    props: {
        url: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        }
    }
});
